import { allowedFileMimeTypes, maxFileSizeInBytes } from '../../../utility'

export const checkFileSize = (file: File) => file.size <= maxFileSizeInBytes

export const checkFileMimeType = (file: File) => allowedFileMimeTypes.includes(file.type)
